import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const NAV_ITEMS = [{
  label: 'Home',
  to: '/'
}, {
  label: 'Our Ladies',
  to: '/therapists'
}, {
  label: 'Locations',
  to: '/locations'
}, {
  label: 'Services',
  to: '/services'
}, {
  label: 'Book',
  to: '/book'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  React.useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-50 w-full border-b border-lotus-500/20 bg-ink-950/90 backdrop-blur-xl" data-id="element-72" data-mp="ejxhnvdgklpb">
      <nav aria-label="Main navigation" className="mx-auto flex h-24 w-full max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-73" data-mp="9k1lgib05ykb">
        <Link to="/" aria-label="ME time home" className="shrink-0" data-id="element-74" data-mp="1q0e0lyo81kgx">
          <Logo data-id="element-75" data-mp="1kyydm12hh3vw" />
        </Link>

        <div className="hidden items-center gap-8 lg:flex" data-id="element-76" data-mp="1l1uadm2lhmir">
          {NAV_ITEMS.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `text-[11px] font-medium uppercase tracking-[0.24em] transition-colors hover:text-lotus-300 ${isActive ? 'text-lotus-400' : 'text-neutral-300'}`} data-id="element-77" data-mp="9qtxjlr3d5y8">
              {item.label}
            </NavLink>)}
          <Link to="/book" className="glow-pink rounded-full bg-lotus-500 px-7 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-lotus-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-lotus-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950" data-id="element-78" data-mp="3s3ie4nxcgpvo">
            Book Now
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-lg p-2 text-neutral-200 transition-colors hover:text-lotus-500 lg:hidden" data-id="element-79" data-mp="39axqbkwi5ayq">
          {open ? <XIcon className="h-6 w-6" data-id="element-80" data-mp="3b35sjskaqs6q" /> : <MenuIcon className="h-6 w-6" data-id="element-81" data-mp="3629qlkji9g3y" />}
        </button>
      </nav>

      {open && <div id="mobile-menu" className="border-t border-lotus-500/20 bg-ink-900 lg:hidden" data-id="element-82" data-mp="2icfg39mns3mv">
          <ul className="mx-auto flex w-full max-w-7xl flex-col px-5 py-3 sm:px-8" data-id="element-83" data-mp="2ie8kei9subrp">
            {NAV_ITEMS.map(item => <li key={item.to} data-id="element-84" data-mp="2sb4o8aor69px">
                <NavLink to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `block py-3 text-base ${isActive ? 'text-lotus-400' : 'text-neutral-200'}`} data-id="element-85" data-mp="2sc69t93eaelw">
                  {item.label}
                </NavLink>
              </li>)}
            <li className="py-3" data-id="element-86" data-mp="a49671k3lj5d">
              <Link to="/book" className="glow-pink block rounded-full bg-lotus-500 px-6 py-3 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-white" data-id="element-87" data-mp="a37jfztpz87t">
                Book Now
              </Link>
            </li>
          </ul>
        </div>}
    </header>;
}